export const DATA_TABLES_ROW_MINIMUM = 15;
